import { render, staticRenderFns } from "./cost-average-detail-modal.vue?vue&type=template&id=b48f8d88&scoped=true&"
import script from "./cost-average-detail-modal.vue?vue&type=script&lang=js&"
export * from "./cost-average-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f8d88",
  null
  
)

export default component.exports